import logger from '../utils/logger';
/**
 * Gets the highest available life expectancy value from different assessment types
 * @param {Object} formData - The form data containing assessment results
 * @returns {number|null} The highest available life expectancy value or null if none available
 */
export const getHighestAvailableLifeExpectancy = (formData) => {
  logger.info("Life Expectancy Debug:", {
    advanced: {
      value: formData.advanced?.predicted_life_expectancy_adv,
      type: typeof formData.advanced?.predicted_life_expectancy_adv,
    },
    recommended: {
      value: formData.recommended?.predictedLifeExpectancy,
      type: typeof formData.recommended?.predictedLifeExpectancy,
      raw: formData.recommended,
    },
    basic: {
      value: formData.basic?.calculatedLifeExpectancy,
      type: typeof formData.basic?.calculatedLifeExpectancy,
      raw: formData.basic,
    },
    full_form_data: formData,
  });

  if (formData.advanced?.predicted_life_expectancy_adv) {
    return formData.advanced.predicted_life_expectancy_adv;
  }
  if (formData.recommended?.predictedLifeExpectancy) {
    return formData.recommended.predictedLifeExpectancy;
  }
  if (formData.basic?.calculatedLifeExpectancy) {
    return formData.basic.calculatedLifeExpectancy;
  }
  return null;
};
